import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useChatContext } from "../../context/ChatContext";

const Sidebar = ({ onLinkClick }) => {
    const { user, hasRole } = useContext(AuthContext);
    const { unreadMessagesCount } = useChatContext();

    const linkClass =
        "text-white bg-sky-600 px-5 py-2 rounded hover:bg-sky-500 hover:text-white block mb-2 transition-colors duration-200 relative flex justify-between items-center";
    const subHeaderClass = "text-black bg-gray-300 px-5 py-1 rounded block mb-2";

    /* Puhelinmyyjan tili nakee vain tyohonsa kuuluvan (Mika 13.9.2026):
       ei viesteja eika omaa tilia — ilmoitusten muokkaus ja kuvapankki sailyvat. */
    const vainPuhelinmyyja = hasRole(user.roles, "ROLE_PUHELINMYYJA") && !hasRole(user.roles, "ROLE_ADMIN");

    return (
        <>
            {!vainPuhelinmyyja && (
                <>
                    <Link className={linkClass} to="/oma-sivu" onClick={onLinkClick}>
                        Oma tili
                    </Link>
                    <Link className={linkClass} to="/oma-sivu/viestit" onClick={onLinkClick}>
                        Viestit
                        {unreadMessagesCount > 0 && <span className="text-white">{unreadMessagesCount}</span>}
                    </Link>
                </>
            )}
            <Link className={linkClass} to="/oma-sivu/ilmoitukset" onClick={onLinkClick}>
                Ilmoitukset
            </Link>
            <Link className={linkClass} to="/oma-sivu/kuvapankki" onClick={onLinkClick}>
                Kuvapankki
            </Link>
            {hasRole(user.roles, "ROLE_SEO") && (
                <>
                    <div className={subHeaderClass}>HALLINTA</div>
                    <Link className={linkClass} to="/hallinta/alueet" onClick={onLinkClick}>
                        Alueet
                    </Link>
                    <Link className={linkClass} to="/hallinta/kohteet" onClick={onLinkClick}>
                        Kohteet
                    </Link>
                    <Link className={linkClass} to="/hallinta/artikkelit" onClick={onLinkClick}>
                        Artikkelit
                    </Link>
                    <Link className={linkClass} to="/hallinta/asetukset" onClick={onLinkClick}>
                        Asetukset
                    </Link>
                </>
            )}
            {hasRole(user.roles, "ROLE_PUHELINMYYJA") && (
                <>
                    <Link className={linkClass} to="/hallinta/puhelinmyynti" onClick={onLinkClick}>
                        Puhelinmyynti
                    </Link>
                    <Link className={linkClass} to="/hallinta/myyjan-opas" onClick={onLinkClick}>
                        Myyjän opas
                    </Link>
                </>
            )}
            {hasRole(user.roles, "ROLE_ADMIN") && (
                <>
                    <Link className={linkClass} to="/hallinta/ilmoitukset" onClick={onLinkClick}>
                        Ilmoitukset
                    </Link>
                    <Link className={linkClass} to="/hallinta/tarjoukset" onClick={onLinkClick}>
                        Tarjoukset
                    </Link>
                </>
            )}
            {hasRole(user.roles, "ROLE_SUPERADMIN") && (
                <>
                    <Link className={linkClass} to="/hallinta/kayttajat" onClick={onLinkClick}>
                        Käyttäjät
                    </Link>
                    <Link className={linkClass} to="/hallinta/luonnokset" onClick={onLinkClick}>
                        Ilmoitusluonnokset
                    </Link>
                    <Link className={linkClass} to="/hallinta/puhelinmyynti-seuranta" onClick={onLinkClick}>
                        Puhelinmyynnin seuranta
                    </Link>
                    <Link className={linkClass} to="/hallinta/sopimukset" onClick={onLinkClick}>
                        Sopimukset
                    </Link>
                    <Link className={linkClass} to="/hallinta/maksusuoritukset" onClick={onLinkClick}>
                        Maksusuoritukset
                    </Link>
                    <Link className={linkClass} to="/hallinta/jalleenmyyntitilaukset" onClick={onLinkClick}>
                        Jälleenmyyntitilaukset
                    </Link>
                    <Link className={linkClass} to="/hallinta/alennuskoodit" onClick={onLinkClick}>
                        Alennuskoodit
                    </Link>
                    <Link className={linkClass} to="/hallinta/tuotteet" onClick={onLinkClick}>
                        Tuotteet
                    </Link>
                    <Link className={linkClass} to="/hallinta/yhteysviestit" onClick={onLinkClick}>
                        Yhteysviestit
                    </Link>
                    <Link className={linkClass} to="/hallinta/liidit" onClick={onLinkClick}>
                        Liidit
                    </Link>
                    <Link className={linkClass} to="/hallinta/sisaltosivut" onClick={onLinkClick}>
                        Sisältösivut
                    </Link>
                </>
            )}
            {hasRole(user.roles, "ROLE_GOD") && (
                <>
                    <div className={subHeaderClass}>GOD</div>
                    <Link className={linkClass} to="/hallinta/toiminnot" onClick={onLinkClick}>
                        Toiminnot
                    </Link>
                </>
            )}
        </>
    );
};

export default Sidebar;
